import { motion } from "framer-motion";

export const PORTAL_URL = "https://portal.apexflowai.co";

export const CALENDLY_URL = "https://calendly.com/donovan-apexflowai/30min";

export const openCalendly = () => {
  window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
};

export const ease = [0.16, 1, 0.3, 1];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease, delay: i * 0.08 },
  }),
};

export function Reveal({ children, className = "", delay = 0, ...props }) {
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-70px" }}
      custom={delay}
      variants={fadeUp}
      {...props}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-2.5 font-sans text-xs uppercase tracking-[0.22em] font-semibold text-brand-gold ${className}`}
    >
      <span className="h-px w-7 bg-brand-gold/60" />
      {children}
    </span>
  );
}

export function BookCallButton({ id = "book-call", label = "Book a Free Revenue Opportunity Call", variant = "dark", className = "" }) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 font-sans text-sm font-semibold tracking-wide transition-all duration-300";
  const styles =
    variant === "gold"
      ? "bg-gradient-to-br from-brand-gold to-brand-gold-deep text-white shadow-luxe-gold hover:-translate-y-0.5 hover:shadow-[0_28px_80px_-18px_rgba(200,154,61,0.55)]"
      : "bg-brand-black text-white shadow-luxe hover:-translate-y-0.5 hover:shadow-[0_28px_70px_-18px_rgba(200,154,61,0.4)]";
  return (
    <button data-testid={id} onClick={openCalendly} className={`${base} ${styles} ${className}`}>
      {label}
    </button>
  );
}
